import ratePlanSimulationApi from '@/api/ratePlanSimulation/ratePlanSimulationApi'

export default {
    name: 'rate-plan-simulation',
    mixins: [],
    extends: {},
    components: {},
    props: [],
    data() {
        return {
            getRatePlanSimulationResp:{
                isNotDefinition:'',
                cmsVoiceDesc:'',
                cmsDataDesc:'',
                suggestionRule:{
                    suggestion1:'',
                    suggestion2:'',
                    suggestion3:'',
                },
                historyContractUsage:[],
            },
        };
    },
    computed: {
    },
    watch: {},
    created() {

    },
    mounted() {
        this.init();
    },
    updated() {},
    beforeDestroy() {},
    methods: {
        async init() {
            this.getRatePlanSimulationResp = await ratePlanSimulationApi.getRatePlanSimulation();

            // 按時間由近到遠排序
			this.getRatePlanSimulationResp.historyContractUsage.sort(function(cu1, cu2){
				return cu2.billMonth - cu1.billMonth;
			});
        }
    },
};


// WEBPACK FOOTER //
// ./src/components/ratePlanSimulation/ratePlanSimulation.js